import CopyContent from '@/ui/components/CopyContent';

const EXPAND_PREVIEW_CHARS = 200;

const truncateExpand = (value: string): string =>
  value.length > EXPAND_PREVIEW_CHARS ? `${value.slice(0, EXPAND_PREVIEW_CHARS)}…` : value;

// Shows a truncated preview but copies the full value — args reprs routinely
// run to thousands of characters.
const CopyableField = ({
  label,
  value,
  className
}: {
  label: string;
  value: string;
  className?: string;
}) => (
  <div className={`wrap-break-word ${className ?? ''}`}>
    <CopyContent content={value} iconPosition="left">
      <span>
        <span className="text-gray-500">{label}:</span> {truncateExpand(value)}
      </span>
    </CopyContent>
  </div>
);

export default CopyableField;
